import { CalendarCheck, FileText, PhoneCall } from "lucide-react";
import { Step, Q_INPUT, Q_LABEL } from "./Step";

function TypeCard({ active, onClick, icon: Icon, title, sub, testId }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className={`text-left p-5 border-2 rounded-sm transition-colors ${active ? "border-[#1E2A78] bg-[#1E2A78]/5" : "border-slate-200 hover:border-slate-300"}`}>
      <Icon className="h-6 w-6 text-[#1E2A78]" />
      <div className="mt-3 font-semibold text-[#0F172A]">{title}</div>
      <div className="text-xs text-slate-500 mt-1">{sub}</div>
    </button>
  );
}

function Field({ label, k, d, set, required, type = "text", span = "" }) {
  return (
    <div className={span}>
      <label className={Q_LABEL}>{label}{required && " *"}</label>
      <input type={type} required={required} value={d[k]} onChange={(e) => set(k, e.target.value)} className={Q_INPUT} data-testid={`quote-field-${k}`} />
    </div>
  );
}

export function QuoteDetailsForm({ details, setDetails, origin }) {
  const set = (k, v) => setDetails({ ...details, [k]: v });
  const booking = details.request_type === "booking";
  const p = { d: details, set };
  return (
    <Step n="5" title="Your details" hint="Save this as a quote, or go ahead and book your pickup / drop-off." testId="quote-step-details">
      <div className="grid sm:grid-cols-2 gap-3 mb-6">
        <TypeCard active={!booking} onClick={() => set("request_type", "quote")} icon={FileText} title="Just a quote" sub="Save this estimate. We'll follow up by email or phone." testId="quote-type-quote" />
        <TypeCard active={booking} onClick={() => set("request_type", "booking")} icon={CalendarCheck} title="Book a pickup / drop-off" sub="Reserve space on the next container." testId="quote-type-booking" />
      </div>
      {booking && origin && !origin.auto_confirm && (
        <div className="mb-5 flex gap-3 p-4 bg-[#FFD700]/15 border border-[#FFD700] rounded-sm text-sm text-[#1E2A78]" data-testid="quote-booking-confirm-notice">
          <PhoneCall className="h-5 w-5 shrink-0 mt-0.5" />
          <span>Your area is outside the GTA (Ontario) and Lower Mainland (BC). Customer service will call you to confirm before your booking is finalized.</span>
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Full name" k="full_name" required {...p} />
        <Field label="Phone" k="phone" type="tel" required {...p} />
        <Field label="Email" k="email" type="email" required span="sm:col-span-2" {...p} />
        {booking && (
          <>
            <Field label="Pickup / sender address" k="address" required span="sm:col-span-2" {...p} />
            <Field label="City" k="city" required {...p} />
            <Field label="Province / State" k="province_state" {...p} />
            <Field label="Postal / ZIP code" k="postal_code" {...p} />
            <Field label="Preferred date" k="preferred_date" type="date" {...p} />
            <Field label="Receiver name (Caribbean)" k="receiver_name" {...p} />
            <Field label="Receiver phone" k="receiver_phone" type="tel" {...p} />
          </>
        )}
        <div className="sm:col-span-2">
          <label className={Q_LABEL}>Notes</label>
          <textarea rows="3" value={details.notes} onChange={(e) => set("notes", e.target.value)} className={Q_INPUT} placeholder="Anything we should know? Contents, access, timing..." data-testid="quote-field-notes" />
        </div>
      </div>
      {booking && (
        <label className="mt-5 flex gap-3 items-start text-sm text-slate-700 cursor-pointer" data-testid="quote-prohibited-label">
          <input type="checkbox" required checked={details.agree_prohibited} onChange={(e) => set("agree_prohibited", e.target.checked)} className="mt-1 h-4 w-4 accent-[#1E2A78]" data-testid="quote-prohibited-checkbox" />
          <span>My shipment contains <b>no prohibited items</b> (firearms, flammables, aerosols, batteries, gas cylinders, drugs, counterfeit goods or restricted food / agricultural products).</span>
        </label>
      )}
    </Step>
  );
}
